module.exports = __webpack_public_path__ + "img/fire.97a62e2b.svg";